import React, { useRef } from "react";
import { Outlet } from "react-router-dom";
import { useDocumentTitle, useRouteTitle } from "./pageTitle";

// The signed-in portal's shell, shared by the investor and Operations layouts (v1.3 ticket 11):
// - RCMC-09: "Skip to main content" is the first focusable element; it moves focus to the page's one main region.
//   The navigation beside it (`navigation`, a SideListView) is the "Main" navigation region.
// - RCMC-07: the tab title names the page the route declares (routes.js `handle.title`), on every navigation.
// Layout and look are v1.2's: the skip link sits off-screen until it has focus, and main keeps the "outer-box" box
// the page content sat in.
// `navigation` may be null (ticket 12: a public page seen signed out, Util/PublicPageLayout): then there is nothing to
// skip, so no skip link. Each part keeps its place in the tree, so navigation arriving later never remounts main.
const PortalShell = ({ navigation }) => {
  const mainRef = useRef(null);
  useDocumentTitle(useRouteTitle());

  // Focus main itself, so the next Tab goes to the page's first control. Main is focusable only for this jump
  // (tabindex -1 until it loses focus): kept focusable, every click on the content would focus it and send the next
  // Tab back to main's first control instead of on from the click. preventDefault: the in-page "#main-content" target
  // would otherwise go into the URL, which the router does not own.
  const skipToMain = (event) => {
    event.preventDefault();
    const main = mainRef.current;
    if (!main) return;
    main.setAttribute("tabindex", "-1");
    main.addEventListener("blur", () => main.removeAttribute("tabindex"), { once: true });
    main.focus();
  };

  return (
    <div className="dashboard-outer-container">
      {navigation && <a className="skip-link" href="#main-content" onClick={skipToMain}>Skip to main content</a>}
      {navigation}
      <main id="main-content" ref={mainRef} className="outer-box">
        <Outlet />
      </main>
    </div>
  );
};

export default PortalShell;
